import { Params } from '../types/types'
import { ALLOW_LIST } from '../constant'
import { HUICE_DEFAULT_URL } from '@/constant'

export function parseURL(url: string, key: string, defaultWorld?: string) {
  if (url.indexOf('?') > -1) {
    let paramStr = url.split('?')[1]
    let paramArr = paramStr.split('&')
    let params: Params = {}
    for (let i = 0; i < paramArr.length; i++) {
      params[paramArr[i].split('=')[0]] = paramArr[i].split('=')[1]
    }
    if (key in params) {
      return decodeURIComponent(params[key])
    }
  }
  return defaultWorld ? defaultWorld : 'erp2'
}

export function extractUrlParam(url: string, key: string, defaultValue?: string) {
  let reg: RegExp = /^[A-Za-z0-9]+$/
  
  if (url.indexOf('?') > -1) {
    let paramStr = url.split('?')[1]
    paramStr = paramStr.split('/#/')[0]
    let paramArr = paramStr.split('&')
    let params: Params = {}
    for (let i = 0; i < paramArr.length; i++) {
      params[paramArr[i].split('=')[0]] = paramArr[i].split('=')[1]
    }
    if (key in params) {
      const value = params[key];
      // 如果value中不含特殊字符
      if (reg.test(value)) {
        return decodeURIComponent(value)
      } else {
        let aimUrl: string[] = []
        for (let i = 0; i < value.length; i++) {
          reg.test(value[i])
            ? aimUrl.push(value[i])
            : aimUrl.push('')
        }
        return decodeURIComponent(aimUrl.join(''))
      }
    }
  }
  return defaultValue || '';
}

export function isEmpty(obj: string | object | undefined) {
  if (typeof obj == 'undefined' || obj == null || obj === '') {
    return true
  } else {
    return false
  }
}

export function urlWrapper(url?: string) {
  if (url && import.meta.env.VITE_ENV === 'production') {
    const host = new URL(url).host;

		const allowTag = ALLOW_LIST.find(v => host.endsWith(v));

    return allowTag ? url : HUICE_DEFAULT_URL
  }

  return url ? url : HUICE_DEFAULT_URL
}

/**
 * 判断是否符合url标砖
 * @param url
 */
export function urlCheck(url: string) {
  let host = url.split('/')[2] as string
  if (host.endsWith('wangdian.cn') || host.endsWith('huice.com')) {
    return true
  } else {
    return false
  }
}

export function isProdEnv() {
  return import.meta.env.VITE_ENV === 'production'
}

/**
 * 判断当前异常是否是定制型的网络异常
 * @param e 网络请求异常进入的e
 * @returns
 */
export function specTimeOutCheck(e): boolean {
  return (
    e.config &&
    e.config.timeoutErrorMessage &&
    e.config.timeoutErrorMessage !== 'timeout' &&
    e.message === e.config.timeoutErrorMessage
  )
}

export interface CatchErrorType<T> {
  response?: T
  error?: object
}

export function catchError<T>(promise: Promise<T>): Promise<CatchErrorType<T>> {
  return promise
    .then((res) => ({
      response: res,
    }))
    .catch((error) => ({
      error: error,
    }))
}

/**
 * 获取当日日期
 * @param date 当前日期毫秒数
 */
export function getNowDate(date: string) {
  if (date == null || date == undefined) {
    return ''
  }
  const timeStap = new Date()
  let Y = timeStap.getFullYear(),
    m = timeStap.getMonth() + 1,
    d = timeStap.getDate(),
    H = timeStap.getHours(),
    i = timeStap.getMinutes(),
    s = timeStap.getSeconds()
  return Y + '-' + m + '-' + d
}

export const isObject = (v: unknown) => {
  return typeof v === 'object' && v !== null
}

export const getLocalStorage = (key: string) => {
  const value = localStorage.getItem(key)
  if (value) {
    try {
      const obj = JSON.parse(value)
      return obj
    } catch (error) {
      return value
    }
  } else {
    return value
  }
}
export const setLocalStorage = (key: string, value: any) => {
  value = isObject(value) ? JSON.stringify(value) : value
  localStorage.setItem(key, value)
}

/**
 * 树形数据转换
 * @param {*} data
 * @param {*} id
 * @param {*} pid
 */
export function treeDataTranslate(data: Array<any>, id = 'id', pid = 'parentId') {
  const arrs: Array<any> = []
  data.forEach((item: any) => {
    if (!item[pid]) {
      arrs.push(item)
    }
  })

  return data.reduce((h, m) => {
    if (m[pid]) {
      foo(h, m)
    }

    function foo(arr, cur) {
      arr.forEach((item) => {
        if (item[id] === cur[pid]) {
          if (!item.children) {
            item.children = []
          }
          item.children.push(cur)
        } else if (item.children) {
          foo(item.children, cur)
        }
      })
    }

    return h
  }, arrs)
}

export function base64Encode(data) {
    const bytes = new TextEncoder().encode(data);
    const binString = Array.from(bytes, (byte) =>
        String.fromCodePoint(byte),
    ).join("");
    return btoa(binString);
}

export function base64Decode(data) {
    const decodedData = atob(data.replace('-','+').replace('_','/'));
    const utf8data = Uint8Array.from(decodedData, (m) => m.codePointAt(0));
    const decoder = new TextDecoder("utf-8");
    return decoder.decode(utf8data);
}

export function sendParentMessage(action: string, data: string) {
    let sendOrigin = location.ancestorOrigins?.[0] || ''
    if (!sendOrigin && document.referrer) {
        //firefox不支持ancestorOrigins, referrer需要指定iframe的refererpolicy
        sendOrigin = new URL(document.referrer).origin
    }

    if(!sendOrigin.endsWith('.huice.com')) {
        console.warn("unsafe orgin:", sendOrigin)
        return;
    }

    window.parent.postMessage(
            JSON.stringify({
                action,
                data,
            }),
            sendOrigin
    )
}

export function notifyParentGo(path) {
    sendParentMessage('redirect', `${location.origin}/#${path}`);
}